import { X } from "lucide-react";

import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { Button, Modal, ModalBody, ModalHeader } from "@design-lab/shared/ui";

type AlertModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  buttonText?: string;
};

export function AlertModal({
  isOpen,
  onClose,
  title,
  message,
  buttonText = "OK"
}: AlertModalProps) {
  const { isDesktop } = useResponsive();

  const modalClassName = isDesktop
    ? "w-[420px] max-w-[90vw] h-auto"
    : "absolute bottom-0 left-0 right-0 flex h-auto max-h-[90vh] w-full flex-col rounded-b-none rounded-t-2xl";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={modalClassName}
      backdropClassName="fixed z-50"
      closeOnBackdropClick={false}
      closeOnEsc={false}
      title={title}
      description={message}
    >
      <ModalHeader className="justify-start border-0 p-4 pb-0 text-base font-medium text-gray-900">
        {title}
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 cursor-pointer"
          data-testid="modal-close-button"
          aria-label="Close"
        >
          <X className="h-6 w-6" />
        </button>
      </ModalHeader>
      <ModalBody className="space-y-4">
        <p className="text-base text-gray-700">{message}</p>

        <Button
          onPress={onClose}
          className="w-full bg-blue-600 px-4 py-2.5 text-white hover:bg-blue-700"
          data-testid="alert-modal-confirm"
        >
          {buttonText}
        </Button>
      </ModalBody>
    </Modal>
  );
}
